module.exports = __webpack_public_path__ + "img/zoom_out.da2543af.svg";